import isChromatic from 'chromatic/isChromatic';
import { useMemo } from 'react';

export const useIsAnimationActive = () =>
  useMemo(() => {
    return !isChromatic();
  }, []);
